import styled from "styled-components";
import { Search } from "../../../Assets/icons";
import SVG from "react-inlinesvg";

export const SwiperStyles = {
    display: 'flex', 
    flexDirection:'row',
    height: '440px', 
    padding: '5px 0',
    paddingInline: '15px',
    width: '600px', 
    
    "--swiper-pagination-color": "#006560", 
    "--swiper-navigation-color": "#006560", 
    "swiperButtonPrev": "#006560", 
    "swiperButtonNext": "#006560"
}

export const cardsStyle = {
    height: '480px', 
    width: '200px', 
}

export const SwiperMobileStyles = {
    display: 'flex', 
    flexDirection:'row',
    height: '130px', 
    paddingInline: '20px',
    width: '100%', 
    "--swiper-pagination-color": "#006560", 
    "--swiper-navigation-color": "#006560", 
    "swiperButtonPrev": "#006560", 
    "swiperButtonNext": "#006560"
}

export const Container = styled.main`
    background: #FFF;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow: ${({$isTourOpen}) => ($isTourOpen ? 'hidden !important' : 'auto')};
    padding: 75px 0 100px;
    width: 100%;
    @media (min-width: 720px) {
        padding: 20px 120px 0 200px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        padding: 5px 20px 0;
    }
`;

export const Header = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 0 10px;

    @media (min-width: 720px) {
        align-items: flex-end;
        margin: 0;
    }
`;

export const ContainerSelect = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: center;
    width: 100%;

    @media (min-width: 720px) {
        flex-direction: row;
        justify-content: space-between;
    }

    div.selects{
        display: flex;
        flex-direction: column;
        gap: 10px;

        @media (min-width: 720px) {
            flex-direction: row;
            gap: 20px;
        }
    }

    .report-buttons-container {
        display: flex;
        gap: 18px;
    }
`;

export const CalendarButton = styled.button`
    border: 2px solid #006560;
    border-radius: 4px;
    cursor: pointer;
    padding: 6px;

    &:hover{
        background-color: #F6F6F6;
        border-color: #33CC99;
    }
`;

export const UpdateIcon = styled(SVG)`   
    height: 20px;
    width: 20px;
    & path {
        fill: ${({ color }) => color};
    }
`;

export const ContainerTop = styled.div`
    display: flex;
    flex: 0.8;
    gap: 10px;
    justify-content: space-around;
    flex-direction: row-reverse;
    @media (min-width: 720px) {
        gap: 30px;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    @media (min-width: 1500px){
        flex-direction: row;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        flex-direction: column;
        gap: 10px;
    }
`;

export const ContainerFocusCard = styled.div`
    display: none;
    align-items: center;
    justify-content: center;
    min-width: 350px;
    min-height: 320px;
    height: 100%;
    @media (min-width: 720px) {
        display: flex;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: none;
    }
`;

export const ContainerFocusCardMobile = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 210px;
    height: 100%;
    @media (min-width: 720px) {
        display: none;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: flex;
    }
`;

export const ContainerCards = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    width: fit-content;
    max-width: 594.546px;
    flex-wrap: wrap;
    @media (min-width: 720px) {
        gap: 20px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        gap: 5px;  
        max-width: 200px;
        min-width: 145px;
    }
`;

export const ContainerCardsSlim = styled.div`
    align-items: center;
    display: none;
    flex-wrap: wrap;
    gap: 20px;
    height: 0px;
    max-width: 594.546px;
    position: relative;
    visibility: hidden;
    width: fit-content;
    @media (min-width: 720px) {
        display: flex;
        height: auto;
        visibility: visible;
        width: auto;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: none;
        height: 0px;
        visibility: hidden;
        width: 0px;
    }

    .swiper-pagination-bullet {
        background: #FFFFFF;
        border: 1px solid #006560;
        padding: 5px;
        opacity: 1;
    }
    .swiper-pagination-bullet-active {
        background-color: #006560
    }
`;

export const SearchInput = styled.input`
    background: url(${Search}) left 5px center / 22px no-repeat;
    border: 1px solid #006560;
    border-radius: 5px;
    color: #333;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    margin-left: 32px;
    outline: #006560;
    padding: 10px 10px 10px 32px;
    width: 246px;

    &:hover{
        background-color: #F2F2F2;
        border-color: #33CC99;
    }
    &::placeholder {
        color: #333;
        opacity: 1;
    }
    &:disabled{
        cursor: not-allowed;
    }
    @media (min-width: 720px) {
        font-size: 16px;
        width: 316px;
    }
`;

export const ContainerCardsSlimMobile = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    margin: auto;
    max-width: 594.546px;
    position: relative;
    width: 100%;
    @media (min-width: 720px) {
        display: none;
        height: 0px;
        visibility: hidden;
        width: 0px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: flex;
        height: auto;
        max-width: 100%;
        padding-bottom: 100px;
        visibility: visible;
        width: auto;
    }
`;

export const ContainerBottom = styled.div`
    align-items: center;
    border : ${props => props.$border};
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 1%;
    margin-bottom: 15px;
    padding: 10px 25px 0px 25px;
    position: relative;
    width: 98%;
    @media (min-width: 720px) {
        margin: 0;
        margin-bottom: 15px;
        width: 100%;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: none;
    }
`;

export const ContainerBottomMobile = styled.div`
    align-items: center;
    border: ${props => props.$border};
    border-radius: 5px;
    display: none;
    flex-direction: column;
    justify-content: center;
    margin: 1%;
    margin-bottom: 15px;
    padding: 10px 25px 0px 25px;
    width: 55%;
    @media(orientation: landscape) and (max-width: 1080px){
        display: flex;
        width: 100%;
    }
`;

export const AlertIcon = styled(SVG)`   
    height: 15px;
    margin-right: 10px;
    width: 15px;
    & path {
        fill: ${({ color }) => color};
    }
`;

export const DayIndicator = styled.div`
    align-items: center;
    align-self: center;
    background: #F6F6F6;
    border-radius: 5px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.25);
    display: flex;
    gap: 20px;
    justify-content: center;
    margin-block: 5px;
    padding: 12px;
    width: 100%;
    @media (min-width: 720px) {
        margin-block: 10px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        margin-block: 5px;
        padding: 10px;
    }
`;

export const StateText = styled.h2`
    color: #333;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    @media (min-width: 720px) {
        font-size: 24px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 16px;
    }
`;

export const StateContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 15px;
    justify-content: space-between;
    width: 100%;
`;

export const StateMonthText = styled.h3`
    background: #FFF;
    border-radius: 5px;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    color: #333;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 8px;
    text-align: flex-start;
    @media (min-width: 720px) {
        font-size: 24px;
        padding: 15px 20px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 15px;
        padding: 8px;
    }
`;

export const ContainerLeft = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

export const CalendarContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;
    width: 100%;
    @media (min-width: 720px) {
        flex-direction: row;
        justify-content: space-between;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        flex-direction: column;
        gap: 20px;  
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: ${props => props.$justify ? props.$justify : 'center'};
    width: ${props => props.$width ? props.$width + "%" : 'auto'};
    @media (min-width: 720px) {
        flex-direction: row;
        justify-content: ${props => props.$justify ? props.$justify : 'space-between'};
        width: 100%;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        flex-direction: row;
    }

    button {
        &:first-child{
            visibility: ${({$sendToEmail}) => !$sendToEmail ? 'hidden' : 'visible'};
        }
    }
`;

export const CardTitle = styled.button`
    align-items: center;
    align-self: center;
    background: ${props => (props.color)};
    border: none;
    border-radius: 15px;
    color: #fff;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    justify-self: center;
    outline: none;
    padding: 8px 18px;
`;

export const ModalCardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const CardsLoader = styled.div`
    display: flex;
    flex-wrap: wrap;   
    gap: 20px;
    max-width: 594.546px;
    width: 100%;
    width: fit-content;
`;

export const LastUpdateContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 10px;
    justify-content: flex-end;

    @media (min-width: 720px) {
        flex-direction: row;
        gap: 20px;
    }

    div.date-time {
        align-items: flex-end;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`;
 
export const LastUpdateIcon = styled.img`
    height: 16px;
    width: 16px;
`;

export const LastUpdateText = styled.span`
    /* align-self: end; */
    color: #333;
    display: flex;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    gap: 10px;
    line-height: normal;
    text-align: center;
    @media (min-width: 720px) {
        padding-right: 0px;
    }
`;

export const ContainerType = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 10px;
    
    div#bardays-landscape-buttons,
    div#bardays-buttons {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
`;

export const ButtonType = styled.button`
    align-items: center;
    background: ${props => props.$selected ? props.color : 'transparent'};
    border: ${props => props.$selected ? '2px solid '+props.color : '2px solid '+props.color};
    border-radius: 5px;
    color: ${props => props.$selected ? '#fff': '#333'};
    cursor: ${props => props.$selected ? 'auto' : 'pointer'};
    display: flex;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    height: 40px;
    justify-content: center;
    line-height: normal;
    outline: none;
    padding: 12px;
    transition: 0.5s;
    &:hover{
        background: ${props => props.$selected ? props.color : 'transparent'};
        color: ${props => props.$selected ? '#fff': '#333'};
        border: ${props => props.$selected ? '2px solid '+props.color : '2px solid '+props.color};
        @media (min-width: 720px) {
            background: ${props => props.$selected ? props.color : props.color};
            color: #fff;
            border: ${props => props.$selected ? '2px solid '+props.color : '2px solid '+props.color};
        }
        @media (orientation: landscape) and (max-width: 1080px){
            background: ${props => props.$selected ? props.color : props.color};
            color: #fff;
            border: ${props => props.$selected ? '2px solid '+props.color : '2px solid '+props.color};
        }
    }
    @media (min-width: 720px) {
        font-size: 15px;
        height: 48px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 12px;
        height: 40px;
    }
`;

export const ModalText = styled.div`
    color: #333;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
`;

export const ImageIcon = styled(SVG)`
    height: 24px;
    width: 24px;
    & path {
        fill: currentColor;
    }
`;

export const OptionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;
    width: 100%;

    @media (min-width: 720px) {
        align-items: flex-start;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    
    @media (orientation: landscape) and (max-width: 1080px){
        flex-direction: column;
        gap: 20px;  
    }

    .container {
        display: flex;
        flex-direction: column;
        width: 100%;

        @media (min-width: 720px) {
            width: 40%;
        }

        &:first-child {
            width: 56%;
        }

        &:last-child {
            width: 100%;
        }
    }

    .file-setup {
        display: flex;
        gap: 10px;
        width: 100%;
    }

    .spreadsheet-setup {
        display: flex;
        gap: 16px;
        margin: 20px 0;
    }

    .file-format {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        justify-content: center;
        margin: 16px 0;
        width: 100%;
        
        @media (min-width: 720px) {
            flex-wrap: nowrap;
            justify-content: space-around;
        }
    }
`;

export const Subtitle = styled.h3`
    color: ${({ $disabled }) => ($disabled ? "#A3A3A3" : "#333")};
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 110%;
`;

export const WarningText = styled.span`
    color: #4361EE;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: ${({ $float }) => ($float ? "end" : "center")};
`;